/**
 * Detect user's operating system
 */
export function detectOS(): 'ios' | 'android' | 'unknown' {
  const userAgent =
    navigator.userAgent || navigator.vendor || (window as any).opera

  // iOS detection
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return 'ios'
  }

  // Android detection
  if (/android/i.test(userAgent)) {
    return 'android'
  }

  return 'unknown'
}

/**
 * Try to open the app directly, fallback to store if app is not installed
 */
export function openAppStore(
  appUrl: { ios: string; android: string },
  deepLinkScheme?: string,
) {
  const os = detectOS()

  if (deepLinkScheme) {
    // Try to open the app directly using deep link
    const appOpened = tryOpenApp(deepLinkScheme)

    // If app didn't open, fallback to store after a delay
    setTimeout(() => {
      if (!appOpened) {
        openStore(appUrl, os)
      }
    }, 1500)
  } else {
    // No deep link available, go directly to store
    openStore(appUrl, os)
  }
}

/**
 * Attempt to open the app using its URL scheme
 */
function tryOpenApp(deepLinkScheme: string): boolean {
  try {
    // Create a hidden iframe to attempt opening the app
    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.src = deepLinkScheme
    document.body.appendChild(iframe)

    // Clean up after attempt
    setTimeout(() => {
      document.body.removeChild(iframe)
    }, 2000)

    // Also try direct navigation (works better on some devices)
    window.location.href = deepLinkScheme

    return true
  } catch (e) {
    console.warn('Failed to open app:', e)
    return false
  }
}

/**
 * Open the appropriate app store
 */
function openStore(
  appUrl: { ios: string; android: string },
  os: 'ios' | 'android' | 'unknown',
) {
  if (os === 'ios') {
    window.location.href = appUrl.ios
  } else if (os === 'android') {
    window.location.href = appUrl.android
  } else {
    // Desktop or unknown: default to iOS link
    window.open(appUrl.ios, '_blank', 'noopener,noreferrer')
  }
}
